import { AdminConsoleAccessGuard, AdminPageContainer, AdminSectionCard } from "../../components/admin-console/admin-console-shell";
import { PageStoreProvider } from "./constructor-services-page.lib";
import { ConstructorServicesList } from "./local-components/constructor-services-list";
import { ConstructorServicesTabs } from "./local-components/constructor-services-tabs";
import { ConstructorServicesToolbar } from "./local-components/constructor-services-toolbar";
import { NewServiceModal } from "./local-components/new-service-modal";

/** ЛК администратора услуг — «Конструктор — Услуги» (внутренний контур, роль «администратор услуг»). */
const ConstructorServicesPage = () => (
  <AdminConsoleAccessGuard>
    <PageStoreProvider>
      <NewServiceModal />
      <AdminPageContainer>
        <AdminSectionCard
          title="Конструктор"
          subtitle="Настройка услуг портала, их бизнес-процессов по дорогам и комплектов документов для заявителей"
        >
          <ConstructorServicesTabs />
          <ConstructorServicesToolbar />
          <ConstructorServicesList />
        </AdminSectionCard>
      </AdminPageContainer>
    </PageStoreProvider>
  </AdminConsoleAccessGuard>
);

export default ConstructorServicesPage;
